import { atom } from "jotai";
import { atomFamily } from "jotai-family";

import type { DisplayEvent } from "@/utils/event-helpers";

export const eventFamily = atomFamily((_slug: string) =>
  atom<DisplayEvent | null>(null),
);
